<script setup lang="ts">
const { t } = useI18n();
const props = defineProps<{
  modelValue?: string;
  title?: string;
  lyrics?: boolean;
  chordSheet?: boolean;
}>();

const toolbarTitle = computed(() => props.title || t("S.LIT_FontSizeTC"));

const emits = defineEmits<{
  (e: "update:modelValue", value: string): void;
}>();

const value = computed({
  get: () => {
    return props.modelValue || "10";
  },
  set: (newValue: string) => {
    emits("update:modelValue", newValue);
  },
});
</script>

<template>
  <ToolbarButtonGroup
    :title="toolbarTitle"
    class="hidden xl:block"
  >
    <FormSlider
      id="LyricsFontSizeInput"
      v-model="value"
      name="FontSize"
      class="desktop-slider my-0"
      :class="{
        'ga-scale-lyrics-font-size' : lyrics,
        'ga-scale-chordsheet-font-size' : chordSheet
      }"
      data-content-action="scaleFontSize"
      :data-content-type="lyrics ? 'Lyrics' : 'ChordSheet'"
      :label="toolbarTitle"
      :increase-label="$t('SV.LIT_IncreaseFontSize')"
      :decrease-label="$t('SV.LIT_DecreaseFontSize')"
      min="10"
      max="32"
      hide-label
    />
  </ToolbarButtonGroup>
  <div class="xl:hidden">
    <div class="label hidden xl:block">{{ toolbarTitle }}</div>
    <ToolbarButtonDropdown
      :label="`${toolbarTitle}: ${value}`"
      icon="fa-text-size"
      html-only
      disable-content-auto-close
    >
      <ToolbarButtonDropdownHeader>{{
        toolbarTitle
      }}</ToolbarButtonDropdownHeader>
      <div
        class="p-2"
        style="width: 200px"
      >
        <FormSlider
          id="LyricsFontSizeInput"
          v-model="value"
          name="FontSize"
          class="my-0"
          :class="{
            'ga-scale-lyrics-font-size' : lyrics,
            'ga-scale-chordsheet-font-size' : chordSheet
          }"
          data-content-action="scaleFontSize"
          :data-content-type="lyrics ? 'Lyrics' : 'ChordSheet'"
          :label="toolbarTitle"
          :increase-label="$t('SV.LIT_IncreaseFontSize')"
          :decrease-label="$t('SV.LIT_DecreaseFontSize')"
          min="10"
          max="32"
          hide-label
        />
      </div>
    </ToolbarButtonDropdown>
  </div>
</template>

<style scoped lang="postcss">
.desktop-slider {
  :deep() {
    .range-group {
      height: 44px;
    }
  }
}
</style>
